<template>
  <div class="app-container">
    <el-form ref="queryForm" inline :model="writeQuery" @submit.native.prevent>
      <div style="text-align: center;display: flex;align-items: center;justify-content: center;">
        <div>
          <el-form-item prop="keyword">
            <el-radio-group v-model="writeQuery.radio">
              <el-radio label="hxm" border>预约</el-radio>
              <el-radio label="pchxm" border>拼场</el-radio>
              <el-radio label="yyhxm" border>邀约</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div style="text-align: center;display: flex;align-items: center;justify-content: center;">
        <div>
          <el-form-item prop="keyword">
            <el-input v-model="writeQuery.verification_code" style="width: 400px;" placeholder="请输入核销码" clearable @keyup.enter.native="writeoff" />
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="writeoff">搜索</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-table :data="writeData" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="verification_code" label="核销码"></el-table-column>
      <el-table-column prop="user_name" label="用户昵称"></el-table-column>
      <el-table-column prop="site_name" label="场馆"></el-table-column>
      <el-table-column prop="public_name" label="场地"></el-table-column>
      <el-table-column prop="coach_name" label="教练姓名">
        <template slot-scope="scope">
          {{ scope.row.coach_name || '~' }}
        </template>
      </el-table-column>
      <el-table-column prop="coach_phone" label="教练电话">
        <template slot-scope="scope">
          {{ scope.row.coach_phone || '~' }}
        </template>
      </el-table-column>
      <el-table-column prop="arrange_time" label="预约日期"></el-table-column>
      <el-table-column prop="start_time" label="预约时间">
        <template slot-scope="scope">
          {{ scope.row.start_time }}~{{ scope.row.end_time }}
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <el-button v-if="writeData[0] && writeData[0].status == 1" type="primary" @click="WriteCode()">核销</el-button>
      <el-button v-else-if="writeData[0]" type="success">已核销</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/api/writeoff.js' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'

export default {
  name: 'Space',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      temp: {},
      writeQuery: {
        radio: 'hxm',
        verification_code: ''
      },
      writeData: [],
      selectedRows: [] // 新增：用于存储选中的行
    }
  },
  created() {

  },
  methods: {
    radioChange() {
      this.writeData = []
      this.writeQuery.verification_code = ''
    },
    // 获取核销码信息
    writeoff() {
      api.getWriteOff(this.writeQuery).then((response) => {
        this.writeData = response.data
      })
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection // 更新选中的行
    },
    // 操作核销
    WriteCode() {
      const verification_codes = this.selectedRows.map(row => row.verification_code)

      api.WriteCode({
        verification_code: verification_codes
      }).then((response) => {
        console.log(response, '++++++++++++++++')
        this.$notify({
          title: '成功',
          message: response.msg,
          type: 'success'
        })
        setTimeout(() => {
          this.writeQuery.verification_code = ''
          this.writeData = []
        }, 1000)
      })
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.changeone = 2
      row.type = row.type.toString()
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    // 上传视频
    uploadVideo(data) {
      this.$router.push({
        path: '/site/video',
        query: { id: data.id, site_id: data.site_id }
      })
    },
    // 门店列表
    siteListSearch() {
      siteapi.getList().then((response) => {
        this.siteList = response.data
      })
    },
    // 场地类型
    getTypeList(id) {
      dict_data
        .getAppointList({ code: 'mdlx', siteid: id })
        .then((response) => {
          this.dictionary = response.data
        })
    },
    // 场地类型
    getTempTypeList(id) {
      dict_data
        .getAppointList({ code: 'mdlx', siteid: id })
        .then((response) => {
          this.Tempdictionary = response.data
          this.$forceUpdate()
        })
    },
    // 更新状态
    changeState(row) {
      api.ChangeStatus({ id: row.id, status: row.status }).then((response) => {
        this.$notify({
          title: '成功',
          message: response.msg,
          type: 'success'
        })
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        name: '',
        status: 1,
        price: '',
        type: '',
        site_id: ''
      }
    }
  }
}
</script>
